import {
  FETCH_APPLICANTS_DATA_FAILURE,
  FETCH_APPLICANTS_DATA_SUCCESS,
  FETCH_LISTING_APPLICATIONS_FAILURE,
  FETCH_LISTING_APPLICATIONS_SUCCESS,
} from '../constants/actionTypes';

const initState = () => ({
  listingApplicationsLoaded: null,
  applicantsDataLoaded: null,
});

function initRequestStatus(state = initState(), action = {}) {
  const { type } = action;

  let newState;
  switch (type) {
    case FETCH_LISTING_APPLICATIONS_SUCCESS:
      return { ...state, listingApplicationsLoaded: true };
    case FETCH_LISTING_APPLICATIONS_FAILURE:
      return { ...state, listingApplicationsLoaded: false };
    case FETCH_APPLICANTS_DATA_SUCCESS:
      return { ...state, applicantsDataLoaded: true };
    case FETCH_APPLICANTS_DATA_FAILURE:
      return { ...state, applicantsDataLoaded: false };
    default:
      newState = state;
      break;
  }
  return newState;
}

export default initRequestStatus;
